import { Directive } from '@angular/core';


@Directive({ selector: 'select2-hint' })
export class Select2Hint {}
